import React from 'react';
import styled from 'styled-components';
import { FaInstagram, FaTwitter, FaTiktok, FaYoutube, FaLinkedinIn } from 'react-icons/fa';
import { FaFacebook } from 'react-icons/fa';
import { FaStar } from 'react-icons/fa';
import FooterLinks from './FooterLinks';

const FooterContainer = styled.footer`
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  padding: 40px 20px;
  width: 100%;
  font-family: 'Poppins', sans-serif;
  border-top: 1px solid #dbe7f7;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Logo = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  width: 200px;
`;

const LinkColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const ColumnTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #0b3d73;
`;

const ColumnLink = styled.a`
  color: #2b4258;
  text-decoration: none;
  margin-bottom: 8px;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
    color: #1f6fd1;
  }
`;

const SettingsButton = styled.button`
  color: #2b4258;
  text-decoration: none;
  margin-bottom: 8px;
  font-size: 14px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;

  &:hover {
    text-decoration: underline;
    color: #1f6fd1;
  }
`;

const BottomSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 10px;
`;

const SocialIcon = styled.a`
  color: #2b4258;
  &:hover {
    color: #1f6fd1;
  }
`;

const TrustpilotSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  width: 50%;
`;

const AppStoreButtons = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
`;

const AppStoreButton = styled.a`
  display: inline-block;
  img {
    height: 40px;
  }
`;

const BottomLinks = styled.div`
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
`;

const Copyright = styled.p`
  font-size: 12px;
  color: #666;
  text-align: center;
  margin-top: 10px;
`;

const StarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin: 10px 0;
`;

export default function Footer() {
  return (
    <FooterContainer>
      <FooterContent>
        <Logo>
          <img src="/TUT.svg" alt="TradesUTrust Logo" />
        </Logo>
        <LinkColumns>
          <Column>
            <ColumnTitle>Posting a job</ColumnTitle>
            <ColumnLink href="/how-it-works">How to find the best Trades</ColumnLink>
            <ColumnLink href="/find-tradesman">Find trades</ColumnLink>
            <ColumnLink href="/comingsoon">Customer helpdesk</ColumnLink>
            <ColumnLink href="/comingsoon">Ask a tradesperson</ColumnLink>
          </Column>
          <Column>
            <ColumnTitle>Register as Tradesperson</ColumnTitle>
            <ColumnLink href="/tradesignup">Quality requirements</ColumnLink>
            <ColumnLink href="/comingsoon">Tradespeople helpdesk</ColumnLink>
            <ColumnLink href="/resources">Resources</ColumnLink>
          </Column>
          <Column>
            <ColumnTitle>About us</ColumnTitle>
            <ColumnLink href="/comingsoon">Our mission</ColumnLink>
            <ColumnLink href="/comingsoon">Partners</ColumnLink>
            <ColumnLink href="/comingsoon">Partners</ColumnLink>
            <FooterLinks />
          </Column>
          <Column>
            <ColumnTitle>Trades</ColumnTitle>
            <ColumnLink href="/comingsoon">What should you be paying for services</ColumnLink>
          </Column>
        </LinkColumns>
        <BottomSection>
          <SocialIcons>
            <SocialIcon href="https://www.facebook.com/people/Trades-U-Trust/61574676070793/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebook size={24} />
            </SocialIcon>
            <SocialIcon href="https://www.instagram.com/tradesutrust/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram size={24} />
            </SocialIcon>
            <SocialIcon href="https://x.com/tradesutrust" target="_blank" rel="noopener noreferrer" aria-label="X">
              <FaTwitter size={24} />
            </SocialIcon>
            <SocialIcon href="https://www.youtube.com/@tradesutrust" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <FaYoutube size={24} />
            </SocialIcon>
            <SocialIcon href="https://www.linkedin.com/company/tradesutrust/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedinIn size={24} />
            </SocialIcon>
            <SocialIcon href="https://www.tiktok.com/@tradesutrust" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <FaTiktok size={24} />
            </SocialIcon>
          </SocialIcons>
          <TrustpilotSection>
            <StarContainer>
              {[...Array(5)].map((_, i) => (
                <FaStar key={i} color="#FFD700" size={18} />
              ))}
            </StarContainer>
          </TrustpilotSection>
          <AppStoreButtons>
            <AppStoreButton href="/comingsoon">
              <img src="/appstore.png" alt="Download on the App Store" />
            </AppStoreButton>
            <AppStoreButton href="/comingsoon">
              <img src="/googleplay.png" alt="Get it on Google Play" />
            </AppStoreButton>
          </AppStoreButtons>
        </BottomSection>
        <BottomLinks>
          <ColumnLink href="/privacy">Privacy</ColumnLink>
          <ColumnLink href="/cookie">Cookie policy</ColumnLink>
          <SettingsButton type="button" onClick={() => window.dispatchEvent(new Event('open-cookie-settings'))}>
            Cookie settings
          </SettingsButton>
          <ColumnLink href="/terms-and-conditions">Terms and conditions</ColumnLink>
        </BottomLinks>
        <Copyright>© 2024 - {new Date().getFullYear()} TradesUTrust. All rights reserved.</Copyright>
      </FooterContent>
    </FooterContainer>
  );
}
